import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    }
  ],
  modifiers: [],
  states: []
}

const renderPages = (dataBreadcrumb) =>
  dataBreadcrumb?.map((item, index) => (
    <li key={index} className="mdn-Breadcrumb-list-item">
      <a
        className="mdn-Breadcrumb-link"
        role="link"
        aria-current="location"
        target={item.target}
        href={item.url}
        {...item.props}
      >
        {item.page}
      </a>
      <span className="mdn-Breadcrumb-icon mdn-Icon-direita mdn-Icon--md"></span>
    </li>
  ))

export default function Breadcrumb(props) {
  const { dataBreadcrumb, data, ...rest } = props
  const _props = clearProps(props)
  return (
    <nav
      {...rest}
      aria-label="breadcrumbs"
      className={resolveProps(_props, config, 'Breadcrumb')}
    >
      <ol className="mdn-Breadcrumb-list">
        {renderPages(data || dataBreadcrumb)}
      </ol>
    </nav>
  )
}

Breadcrumb.propTypes = {
  dataBreadcrumb: PropTypes.shape({
    page: PropTypes.string,
    url: PropTypes.string
  }),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      page: PropTypes.string,
      url: PropTypes.string
    })
  )
}
